import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { createRouterMiddleware } from 'redux-router-kit';

import accountSwitcherMiddleware from 'app/common/middlewares/accountSwitcherMiddleware';
import autoRouteMiddleware from 'app/common/middlewares/autoRouteMiddleware';
import clearAddThisMiddleware from 'app/common/middlewares/clearAddThisMiddleware';
import createAuthenticationMiddleware from 'app/common/middlewares/authenticationMiddleware';
import createAutoPromiseMiddleware from 'app/common/middlewares/autoPromiseMiddleware';
import createScrollToTopMiddleware from 'app/common/middlewares/scrollToTopMiddleware';
import fetchMiddleware from 'app/common/middlewares/fetchMiddleware';
import localStorageEnforcementMiddleware from 'app/common/middlewares/localStorageEnforcementMiddleware';
import {
  arrayMiddleware,
  localStorageMiddleware,
  sentryErrorsMiddleware,
  validateActionMiddleware,
  thunkPromiseMiddleware,
} from '@zapier/toolbox-redux-framework';
import loggerMiddleware from 'app/common/middlewares/loggerMiddleware';
import openExternalBlogLinksNewTabMiddleware from 'app/common/middlewares/openExternalBlogLinksNewTabMiddleware';
import safeRedirectMiddleware from 'app/common/middlewares/safeRedirectMiddleware';
import timeToMountTrackingMiddleware from 'app/common/middlewares/timeToMountTrackingMiddleware';
import trackMiddleware from 'app/common/middlewares/trackMiddleware';
import hardRefreshMiddleware from 'app/common/middlewares/hardRefreshMiddleware';

export default function buildMiddleware(routes) {
  // Create route based-middleware
  const routerMiddleware = createRouterMiddleware({
    routes,
    batchedUpdates: ReactDOM.unstable_batchedUpdates,
  });
  const autoPromiseMiddleware = createAutoPromiseMiddleware({ routes });
  const authMiddleware = createAuthenticationMiddleware({ routes });
  const scrollToTopMiddleware = createScrollToTopMiddleware({ routes });

  const allMiddleware = [
    timeToMountTrackingMiddleware,
    arrayMiddleware,
    thunkPromiseMiddleware,
    thunkMiddleware,
    autoRouteMiddleware,
    autoPromiseMiddleware,
    sentryErrorsMiddleware,
    validateActionMiddleware,
    routerMiddleware,
    hardRefreshMiddleware,
    localStorageEnforcementMiddleware,
    accountSwitcherMiddleware,
    authMiddleware,
    safeRedirectMiddleware,
    trackMiddleware,
    loggerMiddleware,
    scrollToTopMiddleware,
    localStorageMiddleware,
    fetchMiddleware,
    clearAddThisMiddleware,
    openExternalBlogLinksNewTabMiddleware,
  ];

  return {
    allMiddleware,
    authMiddleware,
    routerMiddleware,
    scrollToTopMiddleware,
  };
}
